import React from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./Breadcrumbs.module.scss";

interface BreadcrumbItem {
  path: string;
  label: string;
}

const pathToLabel: Record<string, string> = {
  "/": "Главная",
  "/subscriptions": "Абонементы",
  "/subscriptions-forms": "Данные пользователя(-ей)",
  "/subscriptions-profiles": "Выбор профиля",
  "/user-list-profile": "Данные пользователя(-ей)",
  "/halls": "Аренда залов",
  "/halls-calendar": "Выбор даты",
  "/halls-time": "Выбор времени",
  "/rules": "Правила Клуба",
  "/politics": "Политика конфиденциальности",
  "/offer": "Оферта",
  "/profile": "Профиль",
  "/profile/cards": "Мои карты",
  "/profile/subscriptions": "Мои абонементы",
  "/profile/settings": "Настройки",
  "/profile/halls": "Арендованные залы",
  "/profile/history": "История покупок",
  "/profile/myprofiles": "Мои профили",
  "/profile/edit-my-profile": "Редактирование профиля",
  "/profile/change-password": "Смена пароля",
  "/profile/edit-profile": "Редактирование профиля",
  "/profile/payment/confirm": "Подтверждение платежа",
  "/about": "О клубе",
  "/about/clubFoto": "Галерея",
  "/about/hallsFoto": "Галерея",
  "/about/hallsFoto/morePhoto": "Больше фото",
  "/school": "Школа тенниса",
  "/cart": "Корзина",
  "/payment": "Оплата",
  "/payment-success": "Оплата успешна",
  "/payment-error": "Ошибка оплаты",
  "/contacts": "Контакты",
};

export const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const breadcrumbs = generateBreadcrumbs(location.pathname);

  function generateBreadcrumbs(pathname: string): BreadcrumbItem[] {
    const items: BreadcrumbItem[] = [];
    const pathSegments = pathname.split("/").filter(Boolean);

    items.push({ path: "/", label: "Главная" });

    if (pathname === "/halls-time") {
      items.push({ path: "/halls", label: "Аренда залов" });
      items.push({ path: "/halls-calendar", label: "Выбор даты" });
      items.push({ path: "/halls-time", label: "Выбор времени" });
      return items;
    }

    if (pathname === "/halls-calendar") {
      items.push({ path: "/halls", label: "Аренда залов" });
      items.push({ path: "/halls-calendar", label: "Выбор даты" });
      return items;
    }

    if (pathname === "/subscriptions-forms") {
      items.push({ path: "/subscriptions", label: "Абонементы" });
      items.push({ path: "/subscriptions-forms", label: "Данные пользователя(-ей)" });
      return items;
    }

    if (pathname === "/subscriptions-profiles") {
      items.push({ path: "/subscriptions", label: "Абонементы" });
      items.push({ path: "/subscriptions-forms", label: "Данные пользователя(-ей)" });
      items.push({ path: "/subscriptions-profiles", label: "Выбор профиля" });
      return items;
    }

    if (pathname === "/user-list-profile") {
      items.push({ path: "/subscriptions", label: "Абонементы" });
      items.push({ path: "/user-list-profile", label: "Данные пользователя(-ей)" });
      return items;
    }

    if (pathname === "/payment") {
      items.push({ path: "/cart", label: "Корзина" });
      items.push({ path: "/payment", label: "Оплата" });
      return items;
    }

    if (pathname === "/profile/payment/confirm") {
      items.push({ path: "/profile", label: "Профиль" });
      items.push({ path: "/profile/cards", label: "Мои карты" });
      items.push({ path: "/profile/payment/confirm", label: "Подтверждение платежа" });
      return items;
    }

    let currentPath = "";
    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      
      const exactMatch = pathToLabel[currentPath];
      if (exactMatch) {
        items.push({ path: currentPath, label: exactMatch });
      } else {
        const label = segment
          .split("-")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
        items.push({ path: currentPath, label });
      }
    });

    return items;
  }

  if (breadcrumbs.length <= 1) {
    return null;
  }

  return (
    <nav className={styles.breadcrumbs} aria-label="Хлебные крошки">
      <ol className={styles.breadcrumbs__list}>
        {breadcrumbs.map((item, index) => {
          const isLast = index === breadcrumbs.length - 1;
          
          return (
            <li key={item.path} className={styles.breadcrumbs__item}>
              {isLast ? (
                <span className={styles.breadcrumbs__current} aria-current="page">
                  {item.label}
                </span>
              ) : (
                <>
                  <Link to={item.path} className={styles.breadcrumbs__link}>
                    {item.label}
                  </Link>
                  <span className={styles.breadcrumbs__separator} />
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

